module.exports = __webpack_public_path__ + "img/product-ee.b19e4920.svg";